import React from "react";
import { Card, Col, ProgressBar, Row } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";

const SkeletonUrgency = () => (
   <Card className="card-one" style={{ minHeight: "400px" }}>
      <Card.Header>
         <div className="placeholder-glow" style={{ width: "70%" }}>
            <span className="placeholder col-10 d-block" style={{ height: "16px" }}></span>
         </div>
      </Card.Header>
      <Card.Body className="placeholder-glow">
         <Row className="mb-3">
            {Array.from({ length: 5 }).map((_, i) => (
               <Col key={i} className="text-center">
                  <span className="placeholder col-4 d-block mx-auto mb-1" style={{ height: "22px" }}></span>
                  <span className="placeholder col-7 d-block mx-auto mb-1" style={{ height: "12px" }}></span>
                  <span className="placeholder col-5 d-block mx-auto" style={{ height: "10px" }}></span>
               </Col>
            ))}
         </Row>
         <span className="placeholder col-12 d-block" style={{ height: "24px", borderRadius: "4px" }}></span>
         <div className="d-flex align-items-end justify-content-between mt-3" style={{ height: "180px" }}>
            {Array.from({ length: 5 }).map((_, i) => (
               <span
                  key={i}
                  className="placeholder"
                  style={{
                     width: "16%",
                     height: `${30 + Math.random() * 50}%`,
                     borderRadius: "3px",
                  }}
               ></span>
            ))}
         </div>
      </Card.Body>
   </Card>
);

const TermsUrgencyBar = ({ data, isLoading }) => {
   if (isLoading) return <SkeletonUrgency />;

   const { summaryCards, progressSegments, series, categories } = data;

   return (
      <Card className="card-one">
         <Card.Header>
            <Card.Title as="h6">Terms Urgency — Unreconciled by Due Date</Card.Title>
         </Card.Header>
         <Card.Body>
            <div className="d-flex mb-2">
               {summaryCards.map((item, i) => (
                  <div
                     key={i}
                     className="text-center"
                     style={{ width: `${progressSegments[i].now}%`, minWidth: "fit-content" }}
                  >
                     <small className="fw-medium d-block" style={{ color: item.color }}>{item.label}</small>
                     <small className="text-secondary">{item.amount}</small>
                  </div>
               ))}
            </div>
            <ProgressBar style={{ height: "28px", borderRadius: "4px" }}>
               {progressSegments.map((seg, i) => (
                  <ProgressBar
                     key={i}
                     now={seg.now}
                     label={String(seg.label)}
                     style={{ backgroundColor: seg.color, fontSize: "1rem", fontWeight: 600 }}
                  />
               ))}
            </ProgressBar>
            <ReactApexChart
               series={series}
               options={{
                  chart: {
                     parentHeightOffset: 0,
                     stacked: true,
                     toolbar: { show: false },
                  },
                  colors: summaryCards.map((c) => c.color),
                  grid: {
                     borderColor: "rgba(72,94,144, 0.07)",
                     padding: { top: 0, left: 5, bottom: -5 },
                  },
                  plotOptions: {
                     bar: { horizontal: false, columnWidth: "50%", borderRadius: 3 },
                  },
                  stroke: { show: true, width: 2, colors: ["#fff"] },
                  xaxis: {
                     categories,
                     labels: { style: { colors: "#6e7985", fontSize: "10px", fontWeight: "bold" } },
                     axisBorder: { show: false },
                  },
                  yaxis: {
                     labels: { style: { colors: "#6e7985", fontSize: "10px" } },
                  },
                  dataLabels: { enabled: false },
                  fill: { opacity: 1 },
                  states: {
                     hover: { filter: { type: "darken", value: 0.98 } },
                     active: { filter: { type: "none" } },
                  },
                  legend: { show: true, position: "top", horizontalAlign: "left" },
                  tooltip: { enabled: true },
               }}
               type="bar"
               height={220}
               className="mt-3"
            />
         </Card.Body>
      </Card>
   );
};

export default TermsUrgencyBar;

